import { showDeleteApprovalStructureState } from '@/atoms';
import { useDeleteApprovalStructure } from '@/services/approval-structures';
import { Button } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useQueryClient } from '@tanstack/react-query';
import { ModalLayout } from 'moh-ui';
import { useRecoilState } from 'recoil';

export default function DeleteApprovalStructureModal() {
    const [show, setShow] = useRecoilState(showDeleteApprovalStructureState);
    const queryClient = useQueryClient();

    const {
        mutate: deleteApprovalStructure,
        isPending: deletingApprovalStructure,
    } = useDeleteApprovalStructure();

    const handleDelete = async () => {
        if (!show?.approvalStructure?.id) return;

        deleteApprovalStructure(show.approvalStructure.id, {
            onSuccess: (data) => {
                if (data.success) {
                    notifications.show({
                        title: "Success",
                        message: "Approval Structure deleted successfully",
                        color: "green",
                    });
                    queryClient.invalidateQueries({
                        queryKey: ['approval-structures']
                    });
                    setShow(null);
                }
            },
            onError: (error) => {
                notifications.show({
                    title: "Error",
                    message: error.message || "An error occurred",
                    color: "red",
                });
            },
        });
    };

    return (
        <ModalLayout
            open={Boolean(show?.show)}
            onClose={() => setShow(null)}
        >
            <div className="sm:flex sm:items-start">
                <div className="text-center sm:mt-0 sm:text-left">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">Delete Approval Structure</h3>
                    <div className="mt-2">
                        <p className="text-sm text-gray-500">
                            Are you sure you want to delete this approval structure? This action cannot be undone.
                        </p>
                    </div>
                </div>
            </div>
            <div className="mt-5 sm:flex sm:flex-row-reverse gap-5 pt-4 border-t">
                <Button
                    color="red"
                    onClick={handleDelete}
                    loading={deletingApprovalStructure}
                >
                    Delete
                </Button>
                <Button
                    variant="outline"
                    onClick={() => setShow(null)}
                >
                    Cancel
                </Button>
            </div>
        </ModalLayout>
    );
}
